import { render, staticRenderFns } from "./transfer-check.vue?vue&type=template&id=1adaafbd"
import script from "./transfer-check.vue?vue&type=script&lang=js"
export * from "./transfer-check.vue?vue&type=script&lang=js"
import style0 from "./transfer-check.vue?vue&type=style&index=0&id=1adaafbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports